import React from "react";
import TitleComponent from "../_component/ui/TitleComponent.js";

export default function TermsPage() {
  return (
    <>
      <TitleComponent title={"Điều Khoản & Dịch vụ"} />
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <h1 className="fw-bold mb-4">Điều khoản dịch vụ</h1>
            <p className="text-muted mb-4">
              Khi sử dụng nền tảng của chúng tôi, bạn đồng ý tuân thủ các điều
              khoản dịch vụ dưới đây. Vui lòng đọc kỹ để đảm bảo quyền lợi của
              bạn.
            </p>
            <div className="mb-3">
              <h4 className="fw-semibold">1. Chấp nhận điều khoản</h4>
              <ul className="text-muted">
                <li>
                  Bằng cách đăng ký tài khoản hoặc sử dụng dịch vụ của Boost
                  Career, bạn xác nhận rằng bạn đã đọc, hiểu và đồng ý với các
                  điều khoản này. Nếu không đồng ý, vui lòng không sử dụng dịch
                  vụ.
                </li>
              </ul>
            </div>

            <div className="mb-3">
              <h4 className="fw-semibold">2. Dịch vụ của Boost Career </h4>
              <ul className="text-muted">
                <li>Hỗ trợ tìm kiếm việc làm cho ứng viên.</li>
                <li>Hỗ trợ đăng tin tuyển dụng cho nhà tuyển dụng.</li>
                <li>Phân tích hồ sơ cá nhân.</li>
              </ul>
            </div>

            <div className="mb-3">
              <h4 className="fw-semibold">3. Trách nhiệm của người dùng </h4>
              <ul className="text-muted">
                <li>
                  Cung cấp thông tin chính xác, đầy đủ khi đăng ký tài khoản.
                </li>
                <li>
                  Không sử dụng nền tảng cho các mục đích bất hợp pháp, lừa đảo
                  hoặc xâm phạm quyền lợi của người khác.
                </li>
                <li>
                  Không đăng tải nội dung sai sự thật hoặc vi phạm pháp luật.
                </li>
                <li>Chịu trách nhiệm bảo mật thông tin tài khoản của mình.</li>
              </ul>
            </div>

            <div className="mb-3">
              <h4 className="fw-semibold">4. Trách nhiệm của Boost Career </h4>
              <ul className="text-muted">
                <li>
                  Đảm bảo nền tảng hoạt động ổn định và bảo mật thông tin người
                  dùng.
                </li>
                <li>
                  Hỗ trợ người dùng trong quá trình tìm việc và tuyển dụng.
                </li>
              </ul>
            </div>

            <div className="mb-3">
              <h4 className="fw-semibold">5. Giới hạn trách nhiệm </h4>
              <ul className="text-muted">
                <li>
                  Boost Career chỉ đóng vai trò là nền tảng kết nối giữa nhà
                  tuyển dụng và ứng viên. Chúng tôi không chịu trách nhiệm về
                  tính chính xác của thông tin tuyển dụng hoặc hồ sơ ứng viên,
                  cũng như bất kỳ tranh chấp nào phát sinh từ quá trình tuyển
                  dụng.
                </li>
              </ul>
            </div>

            <div className="mb-3">
              <h4 className="fw-semibold">
                6. Tạm ngưng hoặc chấm dứt dịch vụ{" "}
              </h4>
              <ul className="text-muted">
                <li>
                  Boost Career có quyền tạm ngưng hoặc chấm dứt tài khoản của
                  bạn nếu bạn vi phạm các điều khoản hoặc có hành vi gây hại cho
                  nền tảng và cộng đồng.
                </li>
              </ul>
            </div>

            <div className="mb-5">
              <h4 className="fw-semibold">7. Thay đổi điều khoản </h4>
              <ul className="text-muted">
                <li>
                  Boost Career có thể cập nhật điều khoản này theo thời gian.
                  Chúng tôi sẽ thông báo nếu có thay đổi quan trọng.
                </li>
              </ul>
            </div>

            <h1 className="fw-bold mb-4">Quy chế hoạt động</h1>
            <p className="text-muted mb-4">
              Boost Career là nền tảng trực tuyến kết nối giữa người tìm việc và
              nhà tuyển dụng, cung cấp các dịch vụ hỗ trợ tìm kiếm việc làm,
              đăng tin tuyển dụng. Quy chế này quy định các nguyên tắc hoạt động
              nhằm đảm bảo tính minh bạch, công bằng và an toàn cho tất cả người
              dùng.
            </p>

            <div className="mb-3">
              <h4 className="fw-semibold">1. Nguyên tắc chung </h4>
              <ul className="text-muted">
                <li>
                  Người dùng cần tuân thủ các quy định của nền tảng, không sử
                  dụng dịch vụ cho các mục đích vi phạm pháp luật hoặc gây ảnh
                  hưởng tiêu cực đến cộng đồng.
                </li>
                <li>
                  Boost Career đóng vai trò là cầu nối giữa nhà tuyển dụng và
                  ứng viên, không chịu trách nhiệm về nội dung tin tuyển dụng
                  hoặc tính chính xác của thông tin hồ sơ.
                </li>
              </ul>
            </div>

            <div className="mb-3">
              <h4 className="fw-semibold">
                2. Quy định đối với người tìm việc
              </h4>
              <ul className="text-muted">
                <li>Cung cấp thông tin trung thực, chính xác khi tạo hồ sơ.</li>
                <li>
                  Không sử dụng hồ sơ giả mạo hoặc nội dung không phù hợp.
                </li>
                <li>
                  Tuân thủ quy trình ứng tuyển và tôn trọng các thỏa thuận với
                  nhà tuyển dụng.
                </li>
              </ul>
            </div>

            <div className="mb-3">
              <h4 className="fw-semibold">
                3. Quy định đối với nhà tuyển dụng
              </h4>
              <ul className="text-muted">
                <li>
                  Đăng tin tuyển dụng với nội dung trung thực, rõ ràng và hợp
                  pháp.
                </li>
                <li>
                  Không yêu cầu ứng viên đóng phí hoặc tham gia các hoạt động vi
                  phạm pháp luật.
                </li>
                <li>
                  Không lợi dụng nền tảng để thu thập thông tin cá nhân trái
                  phép.
                </li>
                <li>
                  Chịu trách nhiệm về các giao dịch và hợp đồng tuyển dụng với
                  ứng viên.
                </li>
              </ul>
            </div>

            <div className="mb-3">
              <h4 className="fw-semibold">4. Cơ chế xử lý vi phạm</h4>
              <ul className="text-muted">
                <li>Cảnh báo hoặc tạm ngưng tài khoản.</li>
                <li>Gỡ bỏ nội dung vi phạm mà không cần thông báo trước.</li>
                <li>Chấm dứt tài khoản nếu phát hiện vi phạm nghiêm trọng.</li>
              </ul>
            </div>

            <div className="mb-3">
              <h4 className="fw-semibold">5. Quy định về bảo mật thông tin</h4>
              <ul className="text-muted">
                <li>
                  Boost Career cam kết bảo vệ dữ liệu cá nhân theo Chính sách
                  bảo mật.
                </li>
                <li>
                  Người dùng có quyền kiểm soát và cập nhật thông tin cá nhân
                  của mình.
                </li>
                <li>
                  Nhà tuyển dụng chỉ được sử dụng thông tin ứng viên cho mục
                  đích tuyển dụng hợp pháp.
                </li>
              </ul>
            </div>

            <div className="mb-3">
              <h4 className="fw-semibold">6. Hiệu lực và sửa đổi</h4>
              <ul className="text-muted">
                <li>
                  Quy chế này có hiệu lực từ ngày công bố trên trang web Boost
                  Career.
                </li>
                <li>
                  Boost Career có quyền thay đổi nội dung quy chế khi cần thiết,
                  mọi thay đổi sẽ được thông báo công khai.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
